
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var Router = require('@npm/spiferack/router');
var forms = require('../../styles/forms.css');
var styles = require('../../pages/tfa/list.css');
var TfaTable = require('../../components/tfa-table/tfa-table');

var TotpComponent = function (_React$PureComponent) {
  _inherits(TotpComponent, _React$PureComponent);

  function TotpComponent(props) {
    var _this2 = this;

    _classCallCheck(this, TotpComponent);

    var _this = _possibleConstructorReturn(this, (TotpComponent.__proto__ || Object.getPrototypeOf(TotpComponent)).call(this, props));

    _this.deleteTotp = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev, numWebAuthnDevices) {
        var msg, confirm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ev.preventDefault();
                msg = numWebAuthnDevices === 0 ? 'Deleting the last 2FA device will disable 2FA on your account. Are you sure?' : 'Are you sure?';
                confirm = window.confirm(msg);

                if (confirm) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                _this.setState({ deleteInProgress: true });
                Router.get().submit({
                  action: _this.props.deleteTotpURL,
                  method: 'POST',
                  data: { csrftoken: _this.props.csrftoken }
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.setupTotp = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ev) {
        var skipAlert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var confirm;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ev.preventDefault();

                if (skipAlert) {
                  _context2.next = 5;
                  break;
                }

                confirm = window.confirm('This will delete the current authenticator app and redirect you to the setup page. Are you sure?');

                if (confirm) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:

                _this.setState({ setupInProgress: true });
                Router.get().submit({
                  action: _this.props.setupTotpURL,
                  method: 'GET'
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      deleteInProgress: false,
      setupInProgress: false
    };
    return _this;
  }

  _createClass(TotpComponent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        this.props.totpEnabled ? React.createElement(AuthenticatorAppEnabled, {
          deleteTotp: this.deleteTotp,
          setupTotp: this.setupTotp,
          canDelete: this.props.canDelete,
          deleteInProgress: this.state.deleteInProgress,
          setupInProgress: this.state.setupInProgress,
          numWebAuthnDevices: this.props.numWebAuthnDevices
        }) : React.createElement(AuthenticatorAppDisabled, { setupTotp: this.setupTotp, setupInProgress: this.state.setupInProgress })
      );
    }
  }]);

  return TotpComponent;
}(React.PureComponent);

function AuthenticatorAppEnabled(props) {
  var replaceLinkStyle = props.setupInProgress ? styles.disabledReplaceLink : styles.replaceLink;
  var rows = [{
    cells: [React.createElement(
      'span',
      { key: 'totp' },
      'Authenticator app is configured'
    ), React.createElement(
      'button',
      { className: replaceLinkStyle, onClick: function onClick(ev) {
          return props.setupTotp(ev);
        } },
      'Replace'
    ), React.createElement(
      'div',
      { key: 'totp-delete' },
      React.createElement(
        'button',
        {
          'aria-label': 'Delete authenticator app',
          className: forms.deleteButton,
          disabled: !props.canDelete.totp || props.deleteInProgress,
          onClick: function onClick(ev) {
            return props.deleteTotp(ev, props.numWebAuthnDevices);
          }
        },
        '\xD7'
      )
    )],
    key: 'totp',
    label: 'totp-section'
  }];
  return React.createElement(TfaTable, { rows: rows, useHeadings: false });
}

function AuthenticatorAppDisabled(props) {
  var skipAlert = true;
  return React.createElement(
    'div',
    { className: styles.bodyContainer },
    React.createElement(
      'div',
      null,
      'You don\u2019t have an authenticator app configured'
    ),
    React.createElement(
      'div',
      null,
      React.createElement(
        'button',
        {
          'aria-label': 'Setup authenticator app',
          className: styles.gradientButton,
          onClick: function onClick(ev) {
            return props.setupTotp(ev, skipAlert);
          },
          disabled: props.setupInProgress
        },
        'Set up authenticator app'
      )
    )
  );
}

TotpComponent.layout = 'settings';

module.exports = TotpComponent;
  let __hot__
  
  __registry__.register('tfa/totp', module.exports, __hot__)
  